
const options = [
  {
    key: 'pharmacy',
    label: 'sidebar.pharmacy',
    permitted: ['VIEW_RESIDENTS', 'CHANGE_SCHEDULE', 'VIEW_PHARMA_PATIENTS', 'VIEW_MEDICATION_STRIPS', 'BASIC_SUPPORT'],
    svg: 'meds_icon',
    children: [
      {
        key: 'devices',
        label: 'sidebar.devices',
        permitted: ['VIEW_RESIDENTS', 'CHANGE_SCHEDULE', 'VIEW_PHARMA_PATIENTS', 'BASIC_SUPPORT'],
      },
      {
        key: 'medication_strips',
        label: 'sidebar.medication.strips',
        permitted: ['VIEW_MEDICATION_STRIPS', 'BASIC_SUPPORT'],
      },
      {
        key: 'device_events',
        label: 'siderbar.device.events',
        permitted: ['BASIC_SUPPORT'],
      },
    ]
  },
  {
    key: 'users',
    label: 'sidebar.users',
    permitted: ['FACILITY_USERS_ADMIN', 'ACCOUNT_USERS_ADMIN', 'BASIC_SUPPORT'],
    leftIcon: 'ion-android-people'
  },
  {
    key: 'clients',
    label: 'sidebar.clients',
    permitted: ['SUPER_ADMIN', 'MANAGE_FACILITIES'],
    leftIcon: 'ion-android-home'
  },
  {
    key: 'questionnaires',
    label: 'sidebar.questionnaires',
    permitted: ['SUPER_ADMIN', 'BASIC_SUPPORT'],
    leftIcon: 'ion-document'
  },
  // TODO: To be added later when the feature is complete
  // {
  //     key: "karie_users",
  //     label: "sidebar.karieUsers",
  //     permitted:["SUPER_ADMIN"],
  //     leftIcon: "ion-android-phone-portrait"
  // },
  {
    key: 'support',
    label: 'sidebar.support',
    permitted: ['VIEW_RESIDENTS', 'BASIC_SUPPORT'],
    leftIcon: 'ion-android-laptop',
    children: [
      {
        key: 'support/devices',
        label: 'sidebar.support.devices',
        permitted: ['BASIC_SUPPORT'],
      },
      {
        key: 'support/documents',
        label: 'sidebar.support.documents',
        permitted: ['VIEW_RESIDENTS', 'BASIC_SUPPORT'],
      },
      {
        key: 'support/monitoring',
        label: 'sidebar.support.monitoring',
        permitted: ['SUPER_ADMIN', 'BASIC_SUPPORT'],
      },
    ]
  },
  {
    key: 'devices_update',
    label: 'sidebar.devices.update',
    permitted: ['SUPER_ADMIN', 'BASIC_SUPPORT'],
    leftIcon: 'ion-android-download',
  },
  {
    key: 'customerDevices',
    label: "sidebar.customer.devices",
    permitted: ["SUPER_ADMIN", "BASIC_SUPPORT"],
    leftIcon: 'ion-android-pin'
  },
  {
    key: 'manufacturing',
    label: 'sidebar.manufacturing',
    permitted: ['SUPER_ADMIN','MANAGE_MANUFACTURING_DEVICES'],
    leftIcon: 'ion-hammer',
    children: [
      {
        key: 'manufacturing/createDevices',
        label: 'sidebar.manufacturing.add',
        permitted: ['SUPER_ADMIN','MANAGE_MANUFACTURING_DEVICES'],
      },
      {
        key: 'manufacturing/deviceInfo',
        label: 'sidebar.manufacturing.deviceInfo',
        permitted: ['SUPER_ADMIN','MANAGE_MANUFACTURING_DEVICES'],
      }]
  }
];
export default options;
